import React from "react";
import { Link } from "react-router-dom";

import classNames from "classnames";
import { capitalize } from "lodash";
import { Table } from "react-bootstrap";

import { UmpireScheduleProps } from "../types/umpire";

import {
    selectAllSites,
    selectSetting,
} from "../../../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../../../hooks/reduxHooks";
import { defaultDateTimeFormat } from "../../../../../../lib/utils";
import { UmpirePay } from "../../../../../../types/shared";

const Schedule = ({
    umpire,
    gameRatings,
}: UmpireScheduleProps): React.JSX.Element => {
    const umpirePay: Record<number, UmpirePay[]> = {};
    const sites = useAppSelector(selectAllSites);
    const gameSites = Array.from(new Set(umpire?.schedule?.map(g => g.site)));
    gameSites.map(gs => {
        const site = sites.find(s => s.id === gs);
        umpirePay[gs] = useAppSelector(state =>
            selectSetting(state, `${site?.settingPrefix}umpire_pay`),
        )?.setting as UmpirePay[];
    });

    return (
        <>
            <h4 className={classNames("mt-4")}>Current Games</h4>
            <Table striped className={classNames("umpireSchedule")}>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Age</th>
                        <th>Game Details</th>
                        <th>Field</th>
                        <th>Pay</th>
                        <th>Rating</th>
                    </tr>
                </thead>
                <tbody>
                    {umpire.schedule?.map(g => {
                        const gameUmpire = g.umpires?.find(
                            u => u.id === umpire.id,
                        );
                        const gamePay = umpirePay[g.site].find(
                            p => p.ageLevel === g.ageLevel.ageLevel,
                        );
                        const pay = gamePay?.umpires.find(u =>
                            gameUmpire?.location === "plate"
                                ? u.title === "Umpire" ||
                                  u.title === "Plate Umpire"
                                : u.title === "Field Umpire",
                        )?.pay;

                        return (
                            <tr key={`${g.date}-${g.id}`}>
                                <td style={{ width: "15%" }}>
                                    {defaultDateTimeFormat.format(
                                        new Date(g.date),
                                    )}
                                </td>
                                <td style={{ width: "5%" }}>
                                    {g.ageLevel.ageLevel}
                                </td>
                                <td style={{ width: "36%" }}>
                                    <b>{g.leagueName}</b>
                                    <br />
                                    <b>{g.visitor.name || "TBD"}</b> @{" "}
                                    <b>{g.home.name || "TBD"}</b>
                                </td>
                                <td style={{ width: "28%" }}>
                                    <Link
                                        to={`https://www.majorybl.com/fields/${g.fieldId}`}
                                        target="_blank"
                                    >
                                        {g.fieldName}
                                        {g.diamond && (
                                            <>
                                                <br />
                                                Diamond: {g.diamond}
                                            </>
                                        )}
                                        {g.note && (
                                            <>
                                                <br />
                                                Field Note: {g.note}
                                            </>
                                        )}
                                    </Link>
                                </td>
                                <td style={{ width: "10%" }}>
                                    {g.site === 1
                                        ? capitalize(gameUmpire?.location)
                                        : gameUmpire?.location === "plate"
                                          ? `Umpire 1`
                                          : `Umpire 2`}
                                    : ${pay}
                                </td>
                                <td style={{ width: "6%" }}>
                                    <div className={classNames("gameRatings")}>
                                        {gameRatings
                                            .filter(r => r.game.id === g.id)
                                            .map(r => {
                                                return r.ratings.overall ? (
                                                    <span
                                                        key={r.id}
                                                    >{`${r.ratings.overall} / 5`}</span>
                                                ) : (
                                                    <></>
                                                );
                                            })}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </>
    );
};

export default Schedule;
